export default __webpack_public_path__ + "d8f2061b5025b2fa4fc6f17d9a512c7b.png";